
































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import api from "../../api/index";
import Box from "../components/Box.vue";
import Lists from "../components/Lists.vue";
import AccessInvitationModal from "../components/AccessInvitationModal.vue";
import { MONTHS, DAYS } from "@/constants/group";
import GroupForm from "../components/forms/GroupForm.vue";
import GroupUsers from "../components/forms/GroupUsers.vue";
import {perPageOptions} from '@/constants/ListOptions'
const moment = require("moment");

import Map from "../components/Map.vue";

@Component({
	components: {
		Box,
		Map,
		AccessInvitationModal,
    GroupForm,
    GroupUsers
	},
})
export default class AccessProfile extends Lists {
	access: { [key: string]: any } = {
		id: null,
	};

	mapIsOpen = true;

	loading = false;
	isUserProfileModalActive = false;

	isAccessInvitationModalActive = false;

	perPageOptions = perPageOptions
  usersTotalPages = 0;
  usersCurrentPage = 1;
  usersPerPage: number = Number(localStorage.getItem('resultsPerListPage')) || this.perPageOptions[0];

  accessPointsTotalPages = 0;
  accessPointsCurrentPage = 1;
  accessPointsPerPage = 10;

  months = MONTHS;
  days = DAYS;

  condominiumAccessPoints = [];

	async mounted() {
		await api.setToken();
		await this.getAccess();
		this.addAccessIdInBreadcrumb();
    this.getAccessPoints();
	}

  @Watch('usersPerPage')
  perPageChanged() {
    localStorage.setItem('resultsPerListPage', this.usersPerPage.toString())
    if (this.access.users.length > this.usersPerPage) {
      this.usersTotalPages = Math.ceil(this.access.users.length / this.usersPerPage)
    }
    if (this.access.access_points.length > this.accessPointsPerPage) {
      this.accessPointsTotalPages = Math.ceil(this.access.access_points.length / this.accessPointsPerPage)
    }
  }

	async getAccess() {
		try {
			if (!(this.$route.query && this.$route.query.condominiumId)) {
				return
			}
			const res = await api.get(`bo/condominiums/${this.$route.query.condominiumId}/groups/${this.$route.params.accessId}`);
			this.access = res.data;
      this.perPageChanged()
      this.editedGroup = JSON.parse(JSON.stringify(this.access));
		} catch (e) {
			if (e.response.status === 401) {
				console.log(e.response.status);
			}
		}
	}

  async getAccessPoints() {
    try {
      if (!this.$route.query || !this.$route.query.condominiumId) return;

      const res = await api.get(`bo/condominiums/${this.$route.query.condominiumId}/access_points`);

      this.condominiumAccessPoints = res.data;
    } catch (e) {
      if (e.response.status === 401) {
        console.log(e.response.status);
      }
    }
  }

	get usersList() {
	  if (!this.access.id || this.access.users.length < 1) {
	    return []
    }
	  const startIndex = (this.usersCurrentPage - 1) * this.usersPerPage
	  return this.access.users.slice(startIndex, startIndex + this.usersPerPage)
  }

  get accessPointsList() {
    if (!this.access.id || this.access.access_points.length < 1) {
      return []
    }
    const startIndex = (this.accessPointsCurrentPage - 1) * this.accessPointsPerPage
    return this.access.access_points.slice(startIndex, startIndex + this.accessPointsPerPage)
  }

	async sendAccessInvitation(invitation: any) {
		try {
			const res = await api.post(
				"bo/accesses/" + this.$route.params.accessId + "/invitations",
				{ invitation }
			);
			this.getAccess();
			this.$toast.open({
				message: "L'invitation a bien été envoyée",
				type: "is-novaccess-purple",
				duration: 2000,
			});
		} catch (e) {
			if (e.response.status === 201) {
				console.log(e.response.status);
			}
		}
	}

	async resendInvitation(invitationDatas: any, id: any) {
		try {
			const res = await api.post("bo/accesses/" + id + "/invitations", {
				invitation: {
					mobile_phone_number: invitationDatas.mobile_phone_number,
					first_name: invitationDatas.first_name,
					last_name: invitationDatas.last_name,
					started_at: invitationDatas.started_at,
					user_type: "owner",
					owner_title: "test",
				},
			});
			await this.getAccess();
			this.$toast.open({
				message: "L'invitation a bien été renvoyée",
				type: "is-novaccess-purple",
				duration: 2000,
			});
		} catch (e) {
			if (e.response.status === 201) {
				console.log(e.response.status);
			}
		}
	}

	addAccessIdInBreadcrumb() {
		if (!this.access.id) return;
		const crumb: any = document.querySelector(".breadcrumb .is-current");
		crumb.innerHTML = `groupe ${this.access.id}`;
	}

	async deleteAssociation(accessId: any) {
		try {
			const res = await api.delete("bo/accesses/" + accessId + "/association");
			await this.getAccess();
			this.$toast.open({
				message: "Le badge a bien été dissocié",
				type: "is-novaccess-purple",
				duration: 2000,
			});
		} catch (e) {
			if (e.response.status !== 200) {
				console.log(e.response.status);
			}
		}
	}

	// Edition
  editedGroup = {};
  groupFormActive = false;
  groupUsersActive = false;

  initEdit() {
	  this.editedGroup = JSON.parse(JSON.stringify(this.access))
	  this.groupFormActive = true
  }

  initManageUsers() {
    this.editedGroup = JSON.parse(JSON.stringify(this.access))
    this.groupUsersActive = true
  }
}
